// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IRemoveOffersFromFolderRequest,
  TRemoveOffersFromFolderModel,
  IMappers,
  TRemoveOffersFromFolderResponse,
  IRemoveOffersFromFolderResponseError,
} from './types';

export const defaultConfig: TRemoveOffersFromFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/remove-offers-from-folder/',
  requestType: 'json',
} as TRemoveOffersFromFolderModel;

export function createRemoveOffersFromFolderModel(
  parameters: IRemoveOffersFromFolderRequest,
): TRemoveOffersFromFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRemoveOffersFromFolderOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IRemoveOffersFromFolderRequest;
}

export async function fetchRemoveOffersFromFolder<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRemoveOffersFromFolderOptions<TResponse400>): Promise<TRemoveOffersFromFolderResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createRemoveOffersFromFolderModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IRemoveOffersFromFolderResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TRemoveOffersFromFolderResponse;
}
